"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Geometry = require("./Geometry");
var _utils = require("../../utils");
class Feature {
  get geometry() {
    return this._geometry;
  }
  get coordinates() {
    if (!this.geometry) {
      return undefined;
    }
    return this.geometry.coordinates;
  }
  constructor() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // if a geometry object was provided, convert it to a Feature object
    if (data.type && data.coordinates) {
      data = {
        type: 'Feature',
        geometry: data,
        properties: data.properties
      };
    }
    if (!(0, _utils.isEmpty)(data.geometry)) {
      this._geometry = (0, _Geometry.createGeometry)(data.geometry);
      this.properties = data.properties || {};
      if (data.id) {
        this.id = `${data.id}`;
      }
    }
  }
}
var _default = exports.default = Feature;
module.exports = exports.default;